import { render, staticRenderFns } from "./delivery-note.vue?vue&type=template&id=1700214e&"
import script from "./delivery-note.vue?vue&type=script&lang=ts&"
export * from "./delivery-note.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports